import React, { FunctionComponent } from "react";
import { Styles } from "./styles";

export const Loader: FunctionComponent = () => (
    <Styles>
        <div className="loader" />
    </Styles>
);
